import {
  SET_SUPERANNUATION_INFORMATION,
  SET_SELECTED_SUPERANNUATION_INFORMATION,
  SET_SUPERANNUATION_ENTITY_INFORMATION,
  SET_COMPARE_SUPERANNUATIONS_INFO,
  SET_ICE_PROJECTION_MODEL,
  SET_ICE_API_RESPONSE,
  SET_SUPERANNUATION_CHART_MODEL,
} from "../../../helpers/vuex-constants";

export default {
  [SET_SUPERANNUATION_INFORMATION](state, payload) {
    state.superannuationdata = payload;
  },
  [SET_SELECTED_SUPERANNUATION_INFORMATION](state, payload) {
    state.selectedSuperannuation = payload;
  },
  [SET_SUPERANNUATION_ENTITY_INFORMATION](state, payload) {
    state.superannuationEntitiesInfo = payload;
  },
  [SET_COMPARE_SUPERANNUATIONS_INFO](state, payload) {
    state.compareSuperannuations = payload;
  },
  [SET_ICE_PROJECTION_MODEL](state, payload) {
    state.iceProjectionModel = payload;
  },
  async [SET_SUPERANNUATION_CHART_MODEL](state, payload) {
    state.superChartModel = payload;
  },
  [SET_ICE_API_RESPONSE](state, payload) {
    state.iceAPIResponse = payload;
  },
};
